import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import {
  DocumentCollectionApi,
  GetDocumentsDocTypeEnum,
  ListDocumentResponse,
} from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export interface GetDocumentsListPayload extends ListDocumentResponse {
  documentType: GetDocumentsDocTypeEnum;
}

export const getDocumentsList = createAsyncThunk<
  GetDocumentsListPayload,
  GetDocumentsDocTypeEnum,
  ThunkApi
>("getDocumentsList", async (documentType, { rejectWithValue }) => {
  try {
    const documents = await new DocumentCollectionApi().getDocuments(
      documentType,
    );

    return {
      documentType,
      ...documents.data,
    };
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Recupero lista documenti",
      description:
        "Non siamo riusciti a recuperare la lista dei documenti.\n Puoi riprovare o contattare il supporto",
      isDismissible: false,
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
